import React from 'react';
import {usePromiseTracker} from "react-promise-tracker";
import ReactDOM from 'react-dom';

import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import SpinnerBootrap from "./components/SpinnerBootrap";

const LoadingIndicator = () => {
    const {promiseInProgress} = usePromiseTracker();
    return promiseInProgress && <div style={{
        position: 'fixed',
        top: '0',
        left: '0',
        bottom: '0',
        right: '0',
        background: 'rgba(0, 0, 0, 0.15)',
        zIndex: '1',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }}>
        <SpinnerBootrap/>
    </div>
};

ReactDOM.render(
    <React.StrictMode>
        <App/>
        <LoadingIndicator/>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
